import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-max-width q-mx-auto q-ma-sm q-pa-sm" }
const _hoisted_2 = {
  key: 0,
  "aria-atomic": "true",
  "aria-live": "assertive"
}
const _hoisted_3 = { key: 1 }

import { onBeforeMount, onBeforeUnmount, ref } from 'vue';

// Personal components
import QPageTitle from '@components/QPageTitle.vue';
import QBtnValid from '@components/form/QBtnValid.vue';

// Personal libs
import { convertDateToLiterral } from '@shared/lib/date.lib';
import { LogEntry } from '@shared/lib/logger/logger.interface';
import { BusEventEnum } from '@shared/enum/bus/bus-events.enum';
import bus from '@shared/lib/eventbus.lib';
import { LoggerLevelEnum } from '@shared/lib/logger/logger.enum';

/**
 * Emits
 */
 const maxLines = 100

/**
 * Reactive datas
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ConsolePage',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

// Vendor
const emits = __emit;

/**
 * Properties
 */
const logs = ref<LogEntry[]>([]);

function addLog(log: LogEntry) {
  // Insert the log at the beginning of the list
  logs.value?.splice(0, 0, log);

  // Removes logs to keep up to 100 lines
  if (logs.value.length > maxLines) {
    logs.value?.splice(maxLines, logs.value.length - maxLines);
  }
}

/**
 * Hooks
 */
onBeforeMount(() => {
  bus.on(BusEventEnum.LOGGER_DISPLAY_ENTRY, (log: LogEntry) => {
    addLog(log);
  });
});

onBeforeUnmount(() => {
  bus.off(BusEventEnum.LOGGER_DISPLAY_ENTRY);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QPageTitle, { title: `Console` }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(QBtnValid, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (logs.value = [])),
        "icon-left": 'delete_forever',
        label: 'Vider la liste',
        class: "q-mb-sm"
      }),
      (logs.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (log, index) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "no-margin no-padding text-sm",
                style: {"border-bottom":"1px solid black"},
                key: index
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(convertDateToLiterral)(new Date(log.timestamp ?? 0), ' à ', true)), 1 /* TEXT */),
                _createTextVNode(" - " + _toDisplayString(_unref(LoggerLevelEnum)[log.level] ?? '') + " - " + _toDisplayString(log.title ?? '') + " " + _toDisplayString(log.message ?? ''), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
            _createElementVNode("p", null, "Pas de logs à afficher", -1 /* HOISTED */)
          ])))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})